import React from 'react';
import { Box } from '@mui/material';
import { props } from './utils';
import withSkeleton from './withSkeleton';

function Skeleton(props) {
  return (
    <Box
      {...props}
      sx={{
        ...props.sx,
        '& [data-hide-skeleton]': {
          display: 'none',
        },
        '& .MuiTypography-root:not([data-no-skeleton]), & [data-has-skeleton]': {
          display: 'block',
          position: 'relative !important',
          overflow: 'hidden !important',
          userSelect: 'none !important',
          color: 'transparent',
          '&:after': {
            content: '""',
            userSelect: 'none',
            height: 'calc(100% - 2px)',
            width: 'calc(100% - 2px)',
            top: 1,
            left: 1,
            borderRadius: 'inherit',
            bgcolor: 'grey.300',
            position: 'absolute',
            animation: 'skeleton-animation 1.5s ease-in-out 0.5s infinite',
          },
        },
        '& .MuiTypography-root:not([data-no-skeleton])': {
          width: 'fit-content !important',
          '&:after': {
            height: 'calc(100% - 4px)',
            width: 'calc(100% - 2px)',
            borderRadius: 1,
          },
        },
        '& .MuiAvatar-root': {
          color: 'transparent',
        },
      }}
    />
  );
}

Skeleton.props = props;
Skeleton.withSkeleton = withSkeleton;
export default Skeleton;
